/* eslint-disable no-console,no-unused-vars */
export default ( {
	app,
	authService,
	loadedSlices,
	layouts,
} ) => {
	// forcibly load this slice for now, to ensure the language translations are
	// available
	import( "@teaming/slice-teamlike" ).then( async ( { teamlikeSlice, } ) => {
		teamlikeSlice();
		loadedSlices.set( "@teaming/slice-teamlike", true );
	} );

	return []; // no routes yet
};
